webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var MenuStore = function () {
  function MenuStore() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MenuStore);

    this.state = {
      isClosed: true,
      isAnimated: false,
      isBlocked: false
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MenuStore, [{
    key: "openMenu",
    value: function openMenu() {
      this.state.isClosed = false;
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      this.state.isClosed = true;
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      this.state.isClosed === true ? this.state.isClosed = false : this.state.isClosed = true;
    }
  }, {
    key: "menuIsAnimated",
    value: function menuIsAnimated() {
      this.state.isAnimated = true;
    }
  }, {
    key: "menuIsNotAnimated",
    value: function menuIsNotAnimated() {
      this.state.isAnimated = false;
    }
  }, {
    key: "blockMenu",
    value: function blockMenu() {
      this.state.isBlocked = true;
    }
  }, {
    key: "unblockMenu",
    value: function unblockMenu() {
      this.state.isBlocked = false;
    }
  }]);

  return MenuStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (new MenuStore());

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var animMap = __webpack_require__(60);

var AnimationStore = function () {
  function AnimationStore() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimationStore);

    this.state = {
      from: '',
      to: '',
      appear: animMap.default.appear,
      leave: animMap.default.leave
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimationStore, [{
    key: 'setAnimInfo',
    value: function setAnimInfo(from, to) {
      if (animMap.from[from] === undefined || animMap.from[from].to[to] === undefined) {
        this.state.appear = animMap.default.appear;
        this.state.leave = animMap.default.leave;
      } else if (animMap.from[from].to[to] !== undefined) {
        this.state.appear = animMap.from[from].to[to].appear;
        this.state.leave = animMap.from[from].to[to].leave;
      }
    }
  }, {
    key: 'setRouterInfo',
    value: function setRouterInfo(from, to) {
      this.state.from = from;
      this.state.to = to;
      this.setAnimInfo(from, to);
    }
  }]);

  return AnimationStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (new AnimationStore());

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(174),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SmoothScroll__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_in_viewport__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_in_viewport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_in_viewport__);









var Parallax = function (_SmoothScroll) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Parallax, _SmoothScroll);

  function Parallax(options) {
    var vsOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Parallax);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Parallax.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Parallax)).call(this, options, vsOptions));

    _this.parallaxElements = options.parallaxElements || [];
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Parallax, [{
    key: 'onScroll',
    value: function onScroll(e) {
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(Parallax.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Parallax.prototype), 'onScroll', this).call(this, e);
      this.testParallaxElements();
    }
  }, {
    key: 'setParallaxElements',
    value: function setParallaxElements(parallaxElements) {
      this.parallaxElements = parallaxElements;
    }
  }, {
    key: 'testParallaxElements',
    value: function testParallaxElements() {
      for (var i = 0; i < this.parallaxElements.length; i++) {
        __WEBPACK_IMPORTED_MODULE_7_in_viewport___default()(this.parallaxElements[i].el) ? this.parallaxElements[i].inViewport = true : this.parallaxElements[i].inViewport = false;
      }
    }
  }, {
    key: 'moveElement',
    value: function moveElement(elementToMove) {
      var distanceToMove = void 0;

      if (elementToMove.newPosY !== undefined) {
        distanceToMove = elementToMove.newPosY + (this.currentY - this.oldY) * elementToMove.ratio;
      } else {
        distanceToMove = (this.currentY - this.oldY) * elementToMove.ratio;
      }

      this.applyTransform(elementToMove.el, distanceToMove);
      return distanceToMove;
    }
  }, {
    key: 'moveElements',
    value: function moveElements() {
      for (var i = 0; i < this.parallaxElements.length; i++) {
        if (this.parallaxElements[i].inViewport) {
          this.parallaxElements[i].newPosY = this.moveElement(this.parallaxElements[i]);
        }
      }
    }
  }, {
    key: 'animate',
    value: function animate() {
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(Parallax.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Parallax.prototype), 'animate', this).call(this);
      this.parallaxElements && this.moveElements();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.parallaxElements = null;
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(Parallax.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Parallax.prototype), 'destroy', this).call(this);
    }
  }]);

  return Parallax;
}(__WEBPACK_IMPORTED_MODULE_6__SmoothScroll__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Parallax);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(176),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(168),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = {
	"from": {
		"home": {
			"to": {
				"work": {
					"appear": "appearDown",
					"leave": "leaveUp"
				},
				"case-study": {
					"appear": "appearDown",
					"leave": "leaveUp"
				},
				"about": {
					"appear": "appearForward",
					"leave": "leaveForward"
				}
			}
		},
		"work": {
			"to": {
				"home": {
					"appear": "appearUp",
					"leave": "leaveDown"
				},
				"about": {
					"appear": "appearForward",
					"leave": "leaveForward"
				}
			}
		},
		"about": {
			"to": {
				"home": {
					"appear": "appearBackward",
					"leave": "leaveBackward"
				},
				"work": {
					"appear": "appearBackward",
					"leave": "leaveBackward"
				},
				"case-study": {
					"appear": "appearBackward",
					"leave": "leaveBackward"
				}
			}
		},
		"case-study": {
			"to": {
				"home": {
					"appear": "appearUp",
					"leave": "leaveDown"
				},
				"about": {
					"appear": "appearForward",
					"leave": "leaveForward"
				}
			}
		}
	},
	"default": {
		"appear": "appearAnim",
		"leave": "leaveAnim"
	}
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Work__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Grasshopper__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Grasshopper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Grasshopper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UCAT__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UCAT___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_UCAT__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Champs__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Champs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Champs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pepsi__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pepsi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Pepsi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Vidgeo__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Vidgeo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Vidgeo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_NotFound__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_NotFound__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/work',
    name: 'work',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Work___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_4__components_About___default.a
  }, {
    path: '/work/grasshopper',
    name: 'grasshopper',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Grasshopper___default.a
  }, {
    path: '/work/ucat',
    name: 'ucat',
    component: __WEBPACK_IMPORTED_MODULE_6__components_UCAT___default.a
  }, {
    path: '/work/champs',
    name: 'champs',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Champs___default.a
  }, {
    path: '/work/pepsi',
    name: 'pepsi',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Pepsi___default.a
  }, {
    path: '/work/vidgeo',
    name: 'vidgeo',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Vidgeo___default.a
  }, {
    path: '*',
    name: 'notfound',
    component: __WEBPACK_IMPORTED_MODULE_10__components_NotFound___default.a
  }]
}));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(180),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(61);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var HexToRgba = function () {
  function HexToRgba() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, HexToRgba);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(HexToRgba, [{
    key: 'convert',
    value: function convert(hex, alpha) {
      var r = parseInt(hex.slice(1, 3), 16);
      var g = parseInt(hex.slice(3, 5), 16);
      var b = parseInt(hex.slice(5, 7), 16);

      if (alpha) {
        return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
      } else {
        return 'rgb(' + r + ', ' + g + ', ' + b + ')';
      }
    }
  }]);

  return HexToRgba;
}();

/* harmony default export */ __webpack_exports__["a"] = (HexToRgba);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_virtual_scroll__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_virtual_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_virtual_scroll__);




var SmoothScroll = function () {
  function SmoothScroll(options) {
    var vsOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SmoothScroll);

    this.el = vsOptions.el;
    this.ease = options.ease || 0.1;
    this.targetY = 0;
    this.oldY = 0;
    this.currentY = 0;

    this.destroyed = false;
    this.vs = new __WEBPACK_IMPORTED_MODULE_2_virtual_scroll___default.a(vsOptions);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SmoothScroll, [{
    key: 'init',
    value: function init() {
      this.height = this.getHeight();
      this.vs.on(this.onScroll.bind(this));
      this.animate();
    }
  }, {
    key: 'onScroll',
    value: function onScroll(e) {
      this.targetY += e.deltaY;
      this.targetY = Math.max((this.height - window.innerHeight) * -1, this.targetY);
      this.targetY = Math.min(0, this.targetY);
    }
  }, {
    key: 'getHeight',
    value: function getHeight() {
      return this.el.getBoundingClientRect().height;
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      this.height = this.getHeight();
    }
  }, {
    key: 'animate',
    value: function animate() {
      if (this.destroyed) {
        return undefined;
      } else if (this.callbackWhenReachOffset && this.currentY >= this.targetY - 1 && this.currentY <= this.targetY + 1) {
        return this.reachOffset();
      } else {
        requestAnimationFrame(this.animate.bind(this));
      }
      this.oldY = this.currentY;
      this.currentY += this.getRoundedValue((this.targetY - this.currentY) * this.ease);
      this.applyTransform(this.el, this.currentY);
    }
  }, {
    key: 'applyTransform',
    value: function applyTransform(el, transformY) {
      var t = 'translate3d(0, ' + transformY + 'px, 0)';
      var s = el.style;
      s['transform'] = t;
      s['webkitTransform'] = t;
      s['mozTransform'] = t;
      s['msTransform'] = t;
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(offset, callback) {
      this.targetY = offset;

      if (callback) {
        if (this.destroyed) {
          return callback();
        }
        this.scrollToCallback = callback;
        this.callbackWhenReachOffset = true;
      }
    }
  }, {
    key: 'getRoundedValue',
    value: function getRoundedValue(valueToRound) {
      var roundedValue = valueToRound * 1000;
      roundedValue = Math.round(roundedValue);
      roundedValue = roundedValue / 1000;

      return roundedValue;
    }
  }, {
    key: 'reachOffset',
    value: function reachOffset() {
      this.scrollToCallback();
      this.scrollToCallback = null;
      this.callbackWhenReachOffset = false;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.targetY = 0;
      this.currentY = 0;
    }
  }, {
    key: 'off',
    value: function off() {
      this.vs.off();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.destroyed = true;
      this.reset();
      this.vs.destroy();
    }
  }]);

  return SmoothScroll;
}();

/* harmony default export */ __webpack_exports__["a"] = (SmoothScroll);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var LoaderStore = function () {
  function LoaderStore() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LoaderStore);

    this.state = {
      pageReady: false
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LoaderStore, [{
    key: "setPageReady",
    value: function setPageReady() {
      this.state.pageReady = true;
    }
  }, {
    key: "setPageNotReady",
    value: function setPageNotReady() {
      this.state.pageReady = false;
    }
  }]);

  return LoaderStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (new LoaderStore());

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OnMobile__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OnMobile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_OnMobile__);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    OnMobile: __WEBPACK_IMPORTED_MODULE_0__components_OnMobile___default.a
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AboutContent__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AboutContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AboutContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_AnimationStore__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_MenuStore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_3__stores_MenuStore__["a" /* default */].state.isAnimated) {
      var delay = 800;
      var targetedPage = to.name;
      __WEBPACK_IMPORTED_MODULE_2__stores_AnimationStore__["a" /* default */].setRouterInfo(from.name, targetedPage);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* EventBus */].$emit('leave-page', { to: to, from: from });
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.delay(next, delay);
    }
  },
  mounted: function mounted() {
    var overlayTl = new __WEBPACK_IMPORTED_MODULE_5_gsap__["TimelineMax"]({ delay: 0 });
    overlayTl.to(this.$refs.overlay, 0.5, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Expo"].easeOut });
  },

  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    AboutContent: __WEBPACK_IMPORTED_MODULE_1__components_AboutContent___default.a
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_LoaderStore__ = __webpack_require__(66);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var aboutText = __webpack_require__(188).about;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about-content',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      title: aboutText.title,
      content: aboutText.content,
      socialTitle: aboutText.socialTitle,
      networks: aboutText.socialNetworks,
      menuState: __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__["a" /* default */].state,
      loaderState: __WEBPACK_IMPORTED_MODULE_3__stores_LoaderStore__["a" /* default */].state,
      isAppeared: false
    };
  },

  computed: {
    pageReady: function pageReady() {
      return this.loaderState.pageReady;
    },
    menuIsClosed: function menuIsClosed() {
      return this.menuState.isClosed;
    }
  },
  mounted: function mounted() {
    this.$bigTitle = this.$el.querySelectorAll('.about-content__big-title');
    this.events();
    this.loaderReady();
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenEvents();
  },

  methods: {
    events: function events() {
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* EventBus */].$on('leave-page', this.leave);
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* EventBus */].$on('toggle-menu', this.toggleMenu);
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* EventBus */].$on('page-ready', this.loaderReady);
    },
    unlistenEvents: function unlistenEvents() {
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* EventBus */].$off('leave-page', this.leave);
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* EventBus */].$off('toggle-menu', this.toggleMenu);
      __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* EventBus */].$off('page-ready', this.loaderReady);
    },
    loaderReady: function loaderReady() {
      if (!this.isAppeared) {
        this.appear();
        this.isAppeared = true;
      }
    },
    appear: function appear() {
      if (this.isMobile) {
        TweenMax.set(this.$refs.mobile, { display: 'block' });
      } else {
        TweenMax.set(this.$refs.mobile, { display: 'none', autoAlpha: 0 });
      }
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ delay: 0.3 });
      tl.staggerFromTo(this.$refs.aboutContent.children, 1.5, { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeOut }, 0.1);
      tl.fromTo(this.$refs.network, 1.5, { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeOut }, '-=1.3');
    },
    leave: function leave() {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]();
      tl.staggerTo(this.$refs.aboutContent.children, 0.3, { y: 40, autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeIn, overwrite: 'all' }, -0.08);
    },
    toggleMenu: function toggleMenu() {
      this.menuIsClosed ? this.appear() : this.leave();
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['to', 'title'],
  data: function data() {
    return {
      state: __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__["a" /* default */].state
    };
  },
  mounted: function mounted() {
    this.mouseOverAnim = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
    this.mouseOverAnim.to(this.$refs.hoverLine, 0.5, { autoAlpha: 1, scaleX: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeOut });
  },

  methods: {
    onClick: function onClick() {
      this.$router.push({ name: this.to });
    },
    mouseover: function mouseover() {
      this.mouseOverAnim.play();
    },
    mouseout: function mouseout() {
      this.mouseOverAnim.reverse();
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_in_viewport__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_in_viewport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_in_viewport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.events();
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenEvents();
  },

  methods: {
    events: function events() {
      window.addEventListener('wheel', this.isVisible);
    },
    unlistenEvents: function unlistenEvents() {
      window.removeEventListener('wheel', this.isVisible);
    },
    isVisible: function isVisible() {
      if (__WEBPACK_IMPORTED_MODULE_0_in_viewport___default()(this.$refs.video)) {
        if (this.$refs.video.paused) {
          this.$refs.video.play();
        }
      } else if (!this.$refs.video.paused) {
        this.$refs.video.pause();
      }
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NextButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_AnimationStore__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_Parallax__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'champs',
  data: function data() {
    return {
      nextButtons: [{
        title: 'Pepsi Max',
        to: 'pepsi'
      }]
    };
  },
  mounted: function mounted() {
    this.appearAnim();
    this.smoothScroll = new __WEBPACK_IMPORTED_MODULE_6__scripts_Parallax__["a" /* default */](0.1, {
      el: this.$refs.scrollZone,
      mouseMultiplier: 0.4
    });
    this.mountParallaxElements();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__["a" /* default */].state.isAnimated) {
      var delay = 800;
      var targetedPage = to.name;
      __WEBPACK_IMPORTED_MODULE_3__stores_AnimationStore__["a" /* default */].setRouterInfo(from.name, targetedPage);
      __WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* EventBus */].$emit('leave-page', { to: to, from: from });
      __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.delay(next, delay);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenEvents();
    this.smoothScroll.destroy();
  },

  methods: {
    events: function events() {
      window.addEventListener('wheel', this.wheel);
      window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.throttle(this.resize, 200));
    },
    unlistenEvents: function unlistenEvents() {
      window.removeEventListener('wheel', this.wheel);
      window.removeEventListener('resize', __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.throttle(this.resize, 200));
    },
    appearAnim: function appearAnim() {
      var tl = new __WEBPACK_IMPORTED_MODULE_7_gsap__["TimelineMax"]({ onComplete: this.appear });
      tl.fromTo(this.$refs.scrollZone, 0.5, { y: window.innerHeight }, { y: 0, ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Expo"].easeOut });
      tl.staggerFromTo(this.$refs.infos.children, 1, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Expo"].easeOut, force3D: true }, 0.05, '-=0.3');
    },
    appear: function appear() {
      this.smoothScroll.init();
      this.events();
    },
    resize: function resize() {
      this.smoothScroll.onResize();
    },
    wheel: function wheel() {
      // hey
    },
    mountParallaxElements: function mountParallaxElements() {
      var parallaxElements = [{
        el: this.$refs.logo,
        ratio: 0.05
      }, {
        el: this.$refs.shoe,
        ratio: 0.05
      }];
      this.smoothScroll.setParallaxElements(parallaxElements);
    }
  },
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    NextButton: __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default.a,
    CaseStudyVideo: __WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo___default.a
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NextButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_AnimationStore__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_Parallax__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'grasshopper',
  data: function data() {
    return {
      nextButtons: [{
        title: 'Up Close & Tasty',
        to: 'ucat'
      }]
    };
  },
  mounted: function mounted() {
    this.appearAnim();
    this.smoothScroll = new __WEBPACK_IMPORTED_MODULE_6__scripts_Parallax__["a" /* default */](0.1, {
      el: this.$refs.scrollZone,
      mouseMultiplier: 0.4
    });
    this.mountParallaxElements();
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenEvents();
    this.smoothScroll.destroy();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__["a" /* default */].state.isAnimated) {
      var delay = 800;
      var targetedPage = to.name;
      __WEBPACK_IMPORTED_MODULE_3__stores_AnimationStore__["a" /* default */].setRouterInfo(from.name, targetedPage);
      __WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* EventBus */].$emit('leave-page', { to: to, from: from });
      __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.delay(next, delay);
    }
  },

  methods: {
    events: function events() {
      window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.throttle(this.resize, 200));
    },
    unlistenEvents: function unlistenEvents() {
      window.removeEventListener('resize', __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.throttle(this.resize, 200));
    },
    appearAnim: function appearAnim() {
      var tl = new __WEBPACK_IMPORTED_MODULE_7_gsap__["TimelineMax"]({ onComplete: this.appear });
      tl.set(this.$el, { autoAlpha: 1 });
      tl.fromTo(this.$refs.scrollZone, 0.5, { y: window.innerHeight }, { y: 0, ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Expo"].easeOut });
      tl.staggerFromTo(this.$refs.infos.children, 1, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Expo"].easeOut, force3D: true }, 0.05, '-=0.3');
    },
    appear: function appear() {
      this.smoothScroll.init();
      this.events();
    },
    resize: function resize() {
      this.smoothScroll.onResize();
    },
    mountParallaxElements: function mountParallaxElements() {
      var parallaxElements = [{
        el: this.$refs.logo,
        ratio: 0.05
      }, {
        el: this.$refs.header,
        ratio: 0.05
      }];
      this.smoothScroll.setParallaxElements(parallaxElements);
    }
  },
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    NextButton: __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default.a,
    CaseStudyVideo: __WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo___default.a
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stores_AnimationStore__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gsap__);
//
//
//
//
//
//
//
//
//
//
//





var animMap = __webpack_require__(60);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      title: 'Raine Dalusong',
      menuState: __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__["a" /* default */].state
    };
  },

  computed: {
    menuIsClosed: function menuIsClosed() {
      return this.menuState.isClosed;
    }
  },
  mounted: function mounted() {
    this.events();
    this.ready();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__["a" /* default */].state.isAnimated) {
      var delay = 800;
      var targetedPage = to.name;
      __WEBPACK_IMPORTED_MODULE_1__stores_AnimationStore__["a" /* default */].setRouterInfo(from.name, targetedPage);
      __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* EventBus */].$emit('leave-page', { to: to, from: from });
      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.delay(next, delay);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenElements();
  },

  methods: {
    events: function events() {
      __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* EventBus */].$on('toggle-menu', this.toggleMenu);
      __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* EventBus */].$on('leave-page', this.leave);
    },
    unlistenElements: function unlistenElements() {
      __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* EventBus */].$off('toggle-menu', this.toggleMenu);
      __WEBPACK_IMPORTED_MODULE_3__event_bus__["a" /* EventBus */].$off('leave-page', this.leave);
    },
    ready: function ready() {
      this.appearAnim = new __WEBPACK_IMPORTED_MODULE_5_gsap__["TimelineMax"]({ delay: 0 });
      this.appearAnim.to(this.$refs.overlay, 0.5, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Expo"].easeOut });
      this.appearAnim.staggerFromTo(this.$refs.hello.children, 1.5, { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Expo"].easeOut }, 0.1, '-=0.25');
    },
    leave: function leave() {
      this.leaveAnim = new __WEBPACK_IMPORTED_MODULE_5_gsap__["TimelineMax"]();
      this.leaveAnim.staggerTo(this.$refs.hello.children, 0.3, { y: 40, autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Expo"].easeIn, overwrite: 'all' }, '-0.08');
    },
    toggleMenu: function toggleMenu() {
      this.menuIsClosed ? this.ready() : this.leave();
    }
  },
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_HexToRgba_js__ = __webpack_require__(64);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['url', 'text'],
  data: function data() {
    return {
      textColor: '#ffffff',
      buttonStyle: {
        borderColor: new __WEBPACK_IMPORTED_MODULE_0__scripts_HexToRgba_js__["a" /* default */]().convert('#ffffff', 0.3)
      }
    };
  },
  mounted: function mounted() {
    this.buttonHoverAnim = new TimelineLite({ paused: true });
    // this.buttonHoverAnim.to(this.$refs.buttonText, .2,{y: -20, rotationX: 45,autoAlpha: 0, ease: Expo.easeIn})
    // this.buttonHoverAnim.set(this.$refs.buttonText,{y: 20, rotationX: -45})
    // this.buttonHoverAnim.to(this.$refs.buttonText, .2,{y: 0, rotationX: 0,autoAlpha: 1, ease: Expo.easeOut})
    this.buttonHoverAnim.to(this.$refs.button, .5, { borderColor: new __WEBPACK_IMPORTED_MODULE_0__scripts_HexToRgba_js__["a" /* default */]().convert(this.textColor, 1), ease: Expo.easeInOut }, 0);
  },

  methods: {
    buttonHover: function buttonHover() {
      this.buttonHoverAnim.play();
    },
    buttonOut: function buttonOut() {
      this.buttonHoverAnim.reverse();
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['to', 'title'],
  data: function data() {
    return {
      state: __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__["a" /* default */].state
    };
  },

  computed: {
    menuIsClosed: function menuIsClosed() {
      return this.state.isClosed;
    },
    menuIsAnimated: function menuIsAnimated() {
      return this.state.isAnimated;
    },
    isCurrentRoute: function isCurrentRoute() {
      var isCurrentRoute = this.$route.name === this.to ? true : false;
      return isCurrentRoute;
    }
  },
  mounted: function mounted() {
    this.hoverAnim = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
    this.hoverAnim.to(this.$refs.hoverLine, 0.3, { x: '-50%', scaleX: 1, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeOut });
  },

  methods: {
    mouseover: function mouseover() {
      this.hoverAnim.play();
    },
    mouseout: function mouseout() {
      this.hoverAnim.reverse();
    },
    onClick: function onClick() {
      if (!this.menuIsAnimated) {
        if (this.isCurrentRoute) {
          return __WEBPACK_IMPORTED_MODULE_1__event_bus__["a" /* EventBus */].$emit('click-current-link');
        } else if (!this.menuIsAnimated) {
          this.$router.push({ name: this.to });
        }
      }
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NavItem__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NavItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NavItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  data: function data() {
    return {
      state: __WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__["a" /* default */].state,
      navItems: [{
        title: 'Home',
        to: 'home'
      }, {
        title: 'Work',
        to: 'work'
      }, {
        title: 'About',
        to: 'about'
      }]
    };
  },

  computed: {
    isClosed: function isClosed() {
      return this.state.isClosed;
    },
    isBlocked: function isBlocked() {
      return this.state.isBlocked;
    },
    menuIsNotAnimated: function menuIsNotAnimated() {
      return !this.state.isAnimated;
    }
  },
  mounted: function mounted() {
    var el = this.$el;
    this.throttledOnResize = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.throttle(this.onResize, 300);

    this.$menuLines = this.$refs.menuIcon.children;
    this.$menuLinks = this.$refs.menuLinks.children;

    this.events();

    this.iconEnterAnim = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
    this.iconEnterAnim.from(this.$menuLines[0], 0.4, { scaleX: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut }, '0.5');
    this.iconEnterAnim.from(this.$menuLines[2], 0.4, { scaleX: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut }, '-=0.2');
    this.iconEnterAnim.from(this.$menuLines[1], 0.4, { scaleX: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeInOut }, '-=0.3');

    this.iconEnterAnim.play();

    this.openMenuTimeline = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });

    this.openMenuTimeline.to(this.$menuLines[1], 0.3, { x: -10, autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeInOut }).to(this.$menuLines[0], 0.3, { rotation: 45, scaleX: 0.94, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeInOut }, 0).to(this.$menuLines[2], 0.3, { rotation: -45, scaleX: 0.94, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeInOut }, 0).set(this.$refs.menuLinks, { autoAlpha: 1 }, 0).fromTo(this.$refs.menuBackground, 1, { autoAlpha: 0 }, { autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeInOut }, 0).staggerTo(this.$menuLinks, 1.5, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeInOut, force3D: true }, 0.08, 0);
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenEvents();
  },

  methods: {
    events: function events() {
      window.addEventListener('resize', this.throttledOnResize);
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$on('leave-page', this.leavePage);
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$on('close-menu', this.closeMenu);
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$on('click-current-link', this.closeMenu);
    },
    unlistenEvents: function unlistenEvents() {
      window.removeEventListener('resize', this.throttledOnResize);
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$off('click-current-link', this.closeMenu);
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$off('leave-page', this.leavePage);
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$off('close-menu', this.closeMenu);
    },
    onResize: function onResize() {
      if (window.innerWidth < 960 && !this.isClosed) {
        this.closeMenu();
      }
    },
    toggleClose: function toggleClose() {
      if (this.isClosed) {
        this.openMenu();
      } else if (!this.isClosed) {
        this.closeMenu();
      }
    },
    leavePage: function leavePage() {
      if (!this.isClosed) {
        __WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__["a" /* default */].closeMenu();
        this.openMenuTimeline.reverse();
      }
    },
    openMenu: function openMenu() {
      this.openMenuTimeline.play();
      __WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__["a" /* default */].openMenu();
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$emit('toggle-menu', this.isClosed);
    },
    closeMenu: function closeMenu() {
      this.openMenuTimeline.reverse();
      __WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__["a" /* default */].closeMenu();
      __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$emit('toggle-menu', this.isClosed);
    }
  },
  components: {
    NavItem: __WEBPACK_IMPORTED_MODULE_3__components_NavItem___default.a
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'next-button',
  props: ['to', 'title'],
  data: function data() {
    return {
      state: __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__["a" /* default */].state,
      blocked: false,
      isHiding: false
    };
  },
  mounted: function mounted() {
    this.mouseOverAnim = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
    this.mouseOverAnim.to(this.$refs.hoverLine, 0.5, { autoAlpha: 1, scaleX: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeOut });
  },

  methods: {
    onClick: function onClick() {
      var parentSmoothScroll = this.$parent.smoothScroll;
      var offset = (parentSmoothScroll.height - window.innerHeight) * -1;
      __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__["a" /* default */].blockMenu();
      parentSmoothScroll.scrollTo(offset, this.nextProject);
      parentSmoothScroll.off();
    },
    nextProject: function nextProject() {
      this.blocked = true;
      this.leaveAnim();
    },
    leaveAnim: function leaveAnim() {
      var _this = this;

      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_2__stores_MenuStore__["a" /* default */].unblockMenu();
          _this.$router.push({ name: _this.to });
        } });
      tl.add(this.mouseOverAnim.reverse());
      tl.to(this.$refs.background, 0.75, { scaleY: 1.1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeOut }, '-=0.1');
      tl.staggerTo(this.$refs.buttonContent.children, 0.7, { y: -200, autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeIn }, 0.06, '-=1');
      tl.call(this.hideCaseStudy);
      tl.to(this.$refs.background, 0.75, { transformOrigin: '0% 0%', scaleY: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Expo"].easeOut });
    },
    hideCaseStudy: function hideCaseStudy() {
      TweenLite.set(this.$parent.$el, { autoAlpha: 0 });
      this.isHiding = true;
    },
    onMouseOver: function onMouseOver() {
      !this.blocked && this.mouseOverAnim.play();
    },
    onMouseOut: function onMouseOut() {
      !this.blocked && this.mouseOverAnim.reverse();
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  beforeCreate: function beforeCreate() {
    this.$router.replace({ name: 'hello' });
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AboutContent__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AboutContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AboutContent__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    AboutContent: __WEBPACK_IMPORTED_MODULE_0__components_AboutContent___default.a
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NextButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LinkButton__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LinkButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_LinkButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_AnimationStore__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stores_MenuStore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_Parallax__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pepsi',
  data: function data() {
    return {
      nextButtons: [{
        title: 'Vidgeo',
        to: 'vidgeo'
      }]
    };
  },
  mounted: function mounted() {
    this.appearAnim();
    this.smoothScroll = new __WEBPACK_IMPORTED_MODULE_7__scripts_Parallax__["a" /* default */](0.1, {
      el: this.$refs.scrollZone,
      mouseMultiplier: 0.4
    });
    this.mountParallaxElements();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_5__stores_MenuStore__["a" /* default */].state.isAnimated) {
      var delay = 800;
      var targetedPage = to.name;
      __WEBPACK_IMPORTED_MODULE_4__stores_AnimationStore__["a" /* default */].setRouterInfo(from.name, targetedPage);
      __WEBPACK_IMPORTED_MODULE_6__event_bus__["a" /* EventBus */].$emit('leave-page', { to: to, from: from });
      __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.delay(next, delay);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenEvents();
    this.smoothScroll.destroy();
  },

  methods: {
    events: function events() {
      window.addEventListener('wheel', this.wheel);
      window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.throttle(this.resize, 200));
    },
    unlistenEvents: function unlistenEvents() {
      window.removeEventListener('wheel', this.wheel);
      window.removeEventListener('resize', __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.throttle(this.resize, 200));
    },
    appearAnim: function appearAnim() {
      var tl = new __WEBPACK_IMPORTED_MODULE_8_gsap__["TimelineMax"]({ onComplete: this.appear });
      tl.fromTo(this.$refs.scrollZone, 0.5, { y: window.innerHeight }, { y: 0, ease: __WEBPACK_IMPORTED_MODULE_8_gsap__["Expo"].easeOut });
      tl.staggerFromTo(this.$refs.infos.children, 1, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_8_gsap__["Expo"].easeOut, force3D: true }, 0.05, '-=0.3');
    },
    appear: function appear() {
      this.smoothScroll.init();
      this.events();
    },
    resize: function resize() {
      this.smoothScroll.onResize();
    },
    wheel: function wheel() {
      // hey
    },
    mountParallaxElements: function mountParallaxElements() {
      var parallaxElements = [{
        el: this.$refs.can,
        ratio: 0.05
      }, {
        el: this.$refs.game,
        ratio: 0.02
      }];
      this.smoothScroll.setParallaxElements(parallaxElements);
    }
  },
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    NextButton: __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default.a,
    CaseStudyVideo: __WEBPACK_IMPORTED_MODULE_2__components_CaseStudyVideo___default.a,
    LinkButton: __WEBPACK_IMPORTED_MODULE_3__components_LinkButton___default.a
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NextButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LinkButton__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LinkButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LinkButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_AnimationStore__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_Parallax__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ucat',
  data: function data() {
    return {
      nextButtons: [{
        title: 'Champs Sports',
        to: 'champs'
      }]
    };
  },
  mounted: function mounted() {
    this.appearAnim();
    this.smoothScroll = new __WEBPACK_IMPORTED_MODULE_6__scripts_Parallax__["a" /* default */](0.1, {
      el: this.$refs.scrollZone,
      mouseMultiplier: 0.4
    });
    this.mountParallaxElements();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_4__stores_MenuStore__["a" /* default */].state.isAnimated) {
      var delay = 800;
      var targetedPage = to.name;
      __WEBPACK_IMPORTED_MODULE_3__stores_AnimationStore__["a" /* default */].setRouterInfo(from.name, targetedPage);
      __WEBPACK_IMPORTED_MODULE_5__event_bus__["a" /* EventBus */].$emit('leave-page', { to: to, from: from });
      __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.delay(next, delay);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenEvents();
    this.smoothScroll.destroy();
  },

  methods: {
    events: function events() {
      window.addEventListener('wheel', this.wheel);
      window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.throttle(this.resize, 200));
    },
    unlistenEvents: function unlistenEvents() {
      window.removeEventListener('wheel', this.wheel);
      window.removeEventListener('resize', __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.throttle(this.resize, 200));
    },
    appearAnim: function appearAnim() {
      var tl = new __WEBPACK_IMPORTED_MODULE_7_gsap__["TimelineMax"]({ onComplete: this.appear });
      tl.fromTo(this.$refs.scrollZone, 0.5, { y: window.innerHeight }, { y: 0, ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Expo"].easeOut });
      tl.staggerFromTo(this.$refs.infos.children, 1, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_7_gsap__["Expo"].easeOut, force3D: true }, 0.05, '-=0.3');
    },
    appear: function appear() {
      this.smoothScroll.init();
      this.events();
    },
    resize: function resize() {
      this.smoothScroll.onResize();
    },
    wheel: function wheel() {
      // hey
    },
    mountParallaxElements: function mountParallaxElements() {
      var parallaxElements = [{
        el: this.$refs.logo,
        ratio: 0.03
      }, {
        el: this.$refs.main,
        ratio: 0.04
      }, {
        el: this.$refs.smores,
        ratio: 0.04
      }, {
        el: this.$refs.bg1,
        ratio: -0.2
      }, {
        el: this.$refs.main2,
        ratio: 0.04
      }, {
        el: this.$refs.bg2,
        ratio: -0.2
      }];
      this.smoothScroll.setParallaxElements(parallaxElements);
    }
  },
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    NextButton: __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default.a,
    LinkButton: __WEBPACK_IMPORTED_MODULE_2__components_LinkButton___default.a
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NextButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_AnimationStore__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_MenuStore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_Parallax__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vidgeo',
  data: function data() {
    return {
      nextButtons: [{
        title: 'Grasshopper',
        to: 'grasshopper'
      }]
    };
  },
  mounted: function mounted() {
    this.appearAnim();
    this.smoothScroll = new __WEBPACK_IMPORTED_MODULE_5__scripts_Parallax__["a" /* default */](0.1, {
      el: this.$refs.scrollZone,
      mouseMultiplier: 0.4
    });
    this.mountParallaxElements();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_3__stores_MenuStore__["a" /* default */].state.isAnimated) {
      var delay = 800;
      var targetedPage = to.name;
      __WEBPACK_IMPORTED_MODULE_2__stores_AnimationStore__["a" /* default */].setRouterInfo(from.name, targetedPage);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* EventBus */].$emit('leave-page', { to: to, from: from });
      __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.delay(next, delay);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenEvents();
    this.smoothScroll.destroy();
  },

  methods: {
    events: function events() {
      window.addEventListener('wheel', this.wheel);
      window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.throttle(this.resize, 200));
    },
    unlistenEvents: function unlistenEvents() {
      window.removeEventListener('wheel', this.wheel);
      window.removeEventListener('resize', __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.throttle(this.resize, 200));
    },
    appearAnim: function appearAnim() {
      var tl = new __WEBPACK_IMPORTED_MODULE_6_gsap__["TimelineMax"]({ onComplete: this.appear });
      tl.fromTo(this.$refs.scrollZone, 0.5, { y: window.innerHeight }, { y: 0, ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Expo"].easeOut });
      tl.staggerFromTo(this.$refs.infos.children, 1, { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Expo"].easeOut, force3D: true }, 0.05, '-=0.3');
    },
    appear: function appear() {
      this.smoothScroll.init();
      this.events();
    },
    resize: function resize() {
      this.smoothScroll.onResize();
    },
    wheel: function wheel() {
      // hey
    },
    mountParallaxElements: function mountParallaxElements() {
      var parallaxElements = [{
        el: this.$refs.login,
        ratio: 0.04
      }, {
        el: this.$refs.phone1,
        ratio: 0.05
      }, {
        el: this.$refs.phone2,
        ratio: 0.05
      }];
      this.smoothScroll.setParallaxElements(parallaxElements);
    }
  },
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    NextButton: __WEBPACK_IMPORTED_MODULE_1__components_NextButton___default.a
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CaseStudy__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CaseStudy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CaseStudy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_AnimationStore__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_MenuStore__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'work',
  data: function data() {
    return {
      menuState: __WEBPACK_IMPORTED_MODULE_3__stores_MenuStore__["a" /* default */].state,
      isAppeared: false,
      caseStudies: [{
        title: 'Grasshopper',
        to: 'grasshopper'
      }, {
        title: 'Up Close & Tasty',
        to: 'ucat'
      }, {
        title: 'Champs Sports',
        to: 'champs'
      }, {
        title: 'Pepsi Max',
        to: 'pepsi'
      }, {
        title: 'Vidgeo',
        to: 'vidgeo'
      }]
    };
  },

  computed: {
    menuIsClosed: function menuIsClosed() {
      return this.menuState.isClosed;
    }
  },
  mounted: function mounted() {
    this.events();
    this.loaderReady();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_3__stores_MenuStore__["a" /* default */].state.isAnimated) {
      var delay = 800;
      var targetedPage = to.name;
      __WEBPACK_IMPORTED_MODULE_2__stores_AnimationStore__["a" /* default */].setRouterInfo(from.name, targetedPage);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* EventBus */].$emit('leave-page', { to: to, from: from });
      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.delay(next, delay);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unlistenEvents();
  },

  methods: {
    events: function events() {
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* EventBus */].$on('leave-page', this.leave);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* EventBus */].$on('toggle-menu', this.toggleMenu);
    },
    unlistenEvents: function unlistenEvents() {
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* EventBus */].$off('leave-page', this.leave);
      __WEBPACK_IMPORTED_MODULE_4__event_bus__["a" /* EventBus */].$off('toggle-menu', this.toggleMenu);
    },
    loaderReady: function loaderReady() {
      this.appear();
      this.isAppeared = true;
    },
    appear: function appear() {
      var tl = new __WEBPACK_IMPORTED_MODULE_5_gsap__["TimelineMax"]({ delay: 0 });
      tl.to(this.$refs.overlay, 0.5, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Expo"].easeOut });
      tl.staggerFromTo(this.$refs.cases.children, 1.5, { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Expo"].easeOut }, 0.1, '-=0.1');
    },
    leave: function leave() {
      var tl = new __WEBPACK_IMPORTED_MODULE_5_gsap__["TimelineMax"]();
      tl.staggerTo(this.$refs.cases.children, 0.3, { y: 40, autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_5_gsap__["Expo"].easeIn, overwrite: 'all' }, '-0.08');
    },
    toggleMenu: function toggleMenu() {
      this.menuIsClosed ? this.appear() : this.leave();
    }
  },
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    CaseStudy: __WEBPACK_IMPORTED_MODULE_1__components_CaseStudy___default.a
  }
});

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(169),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(172),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(173),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(184),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(171),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(177),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(170),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(182),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(181),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-nav",
    on: {
      "mouseover": _vm.mouseover,
      "mouseout": _vm.mouseout
    }
  }, [_c('a', {
    ref: "link",
    staticClass: "case-study__link",
    attrs: {
      "to": _vm.to
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClick($event)
      }
    }
  }, [_c('span', {
    ref: "title",
    staticClass: "case-study__title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _c('div', {
    ref: "hoverLine",
    staticClass: "case-study__hover"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "aboutContent",
    staticClass: "about-content"
  }, [_c('div', {
    staticClass: "about-content__title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    ref: "mobile",
    staticClass: "about-content__mobile-message"
  }, [_vm._v("View my full portfolio on a desktop machine.")]), _vm._v(" "), _c('div', {
    ref: "contentContainer",
    staticClass: "about-content__content-container"
  }, [_c('div', {
    staticClass: "about-content__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about-content__social"
  }, [_c('div', {
    staticClass: "about-content__social-title"
  }, [_vm._v(_vm._s(_vm.socialTitle))]), _vm._v(" "), _c('div', {
    ref: "network",
    staticClass: "about-content__networks"
  }, _vm._l((_vm.networks), function(network) {
    return _c('div', {
      staticClass: "about-content__network"
    }, [_c('a', {
      staticClass: "about-content__network__link",
      attrs: {
        "href": network.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(network.name))])])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about"
  }, [_c('div', {
    ref: "overlay",
    staticClass: "overlay"
  }), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('div', {
    ref: "about",
    staticClass: "section-title"
  }, [_vm._v("About")]), _vm._v(" "), _c('about-content')], 1)
},staticRenderFns: []}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-pm"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__pepsi"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "game",
    staticClass: "case-study__img case-study__img-cap",
    attrs: {
      "src": "/static/assets/imgs/case-study/pepsi/181q62u.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "can",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/pepsi/Pepsi_MAX_Cherry_16.png",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/static/assets/videos/case-study/pepsi/video.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row-button"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('link-button', {
    attrs: {
      "url": "http://img.mediaplex.com/content/0/0/ActiveLink_jsonly.htm?id=29110-213608-17922-1&ad_url=http://adfarm.mediaplex.com/ad&mpcr=57266411&mpcrset=root",
      "text": "play the demo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content-button"
  }, [_vm._v("(turn off any adblockers)")])], 1)], 1)])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n        Pepsi Max\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Conversant")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Front-End Development")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("2015")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n              The Pepsi Max unit features a game of falling cans. Every can clicked grants two points, while clicking a red cherry blast Pepsi Max can grants bonus points. The more cans clicked, the faster the cans fall.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Technology Stack")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• JavaScript (Internal Framework)")]), _vm._v(" "), _c('li', [_vm._v("• GreenSock Animation Platform")])])])])
}]}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-cs"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__champs"
  }, [_c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "logo",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/champs/champssports1.png"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/static/assets/videos/case-study/champs/ConversantChampsSpaceDemo.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_vm._m(5), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__half-block case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/static/assets/videos/case-study/champs/Champs_prototype_6.mp4",
      "type": "video/mp4"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "shoe",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/champs/77153_fr_sc7_rs.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(6)])], 1)])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n        Champs Sports\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Conversant")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Prototype Development")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("2016")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n              Champs Sports was one of the first clients for Conversant's SPACE (Special Project for the Advancement of Creative Elevation) initiative. SPACE is a week-long brainstorming program where a chosen core team is tasked to design a prototype unit that features functionality that has never been previously explored within Conversant. "), _c('br'), _c('br'), _vm._v("\n\n              The following is the resultant prototype, which focused on showcasing specific products in a unique way. This prototype received approval for a full production build and won increased adspend from the client.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Unit Features")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• Dynamic elements")]), _vm._v(" "), _c('li', [_vm._v("• Accelerometer -based Parallax")]), _vm._v(" "), _c('li', [_vm._v("• GreenSock Animations")]), _vm._v(" "), _c('li', [_vm._v("• Hold to save a dynamic social image")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Technology Stack")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• JavaScript (Internal Framework)")]), _vm._v(" "), _c('li', [_vm._v("• GreenSock Animation Platform")]), _vm._v(" "), _c('li', [_vm._v("• Parallax.js")])])])])
}]}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-gh"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__gh"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "logo",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/grasshopper/Grasshopper.jpg"
    }
  })]), _vm._v(" "), _c('case-study-video', {
    staticClass: "case-study__row case-study__video-row"
  }, [_c('source', {
    attrs: {
      "src": "/static/assets/videos/case-study/grasshopper/gh-animation.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "header",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/grasshopper/Grasshopper_header.jpg",
      "alt": ""
    }
  })])])])], 1)])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n        Grasshopper\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Conversant")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Development")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("09/2016 - Present")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n              Grasshopper is an Adobe Illustrator extension designed and built to aid Art Directors and Production Artists in building digital advertisement units. It exports HTML5 and JavaScript units with a click of a button.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Technology Stack")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• AngularJS")]), _vm._v(" "), _c('li', [_vm._v("• Sass")]), _vm._v(" "), _c('li', [_vm._v("• Node.js")]), _vm._v(" "), _c('li', [_vm._v("• Express")]), _vm._v(" "), _c('li', [_vm._v("• ExtendScript API")]), _vm._v(" "), _c('li', [_vm._v("• Gulp")]), _vm._v(" "), _c('li', [_vm._v("• Jasmine")])])])])
}]}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "menu",
    staticClass: "menu menu--light"
  }, [_c('div', {
    staticClass: "menu-hit",
    on: {
      "click": _vm.toggleClose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-icon__container"
  }, [_c('div', {
    ref: "menuIcon",
    staticClass: "menu-icon"
  }, [_c('div', {
    staticClass: "menu-line menu-line--big"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-line menu-line--big"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-line menu-line--big"
  })])]), _vm._v(" "), _c('div', {
    ref: "menuLinks",
    staticClass: "menu-links"
  }, _vm._l((_vm.navItems), function(navItem) {
    return _c('nav-item', {
      key: navItem.to,
      attrs: {
        "title": navItem.title,
        "to": navItem.to
      }
    })
  })), _vm._v(" "), _c('div', {
    ref: "menuBackground",
    staticClass: "menu-background"
  })])
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-link",
    on: {
      "mouseover": _vm.mouseover,
      "mouseout": _vm.mouseout
    }
  }, [_c('a', {
    ref: "link",
    staticClass: "menu-link__link",
    attrs: {
      "to": _vm.to
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClick($event)
      }
    }
  }, [_c('div', {
    ref: "title",
    staticClass: "menu-link__title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _c('div', {
    ref: "hoverLine",
    staticClass: "menu-link__hover"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "next-button",
    class: {
      'is-hiding': _vm.isHiding
    },
    on: {
      "~click": function($event) {
        $event.preventDefault();
        _vm.onClick($event)
      },
      "mouseover": function($event) {
        $event.preventDefault();
        _vm.onMouseOver($event)
      },
      "mouseout": function($event) {
        $event.preventDefault();
        _vm.onMouseOut($event)
      }
    }
  }, [_c('div', {
    ref: "buttonContent",
    staticClass: "next-button__content"
  }, [_c('div', {
    staticClass: "next-button__subtitle"
  }, [_vm._v("Next project")]), _vm._v(" "), _c('div', {
    staticClass: "next-button__title-container"
  }, [_c('span', {
    staticClass: "next-button__title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        "), _c('div', {
    ref: "hoverLine",
    staticClass: "next-button__line"
  })])])]), _vm._v(" "), _c('div', {
    ref: "background",
    staticClass: "next-button__background"
  })])
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-mobile"
  }, [_c('about-content', {
    attrs: {
      "isMobile": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    ref: "button",
    staticClass: "slide__button link-button",
    style: (_vm.buttonStyle),
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    },
    on: {
      "mouseover": _vm.buttonHover,
      "mouseout": _vm.buttonOut
    }
  }, [_c('div', {
    ref: "buttonText",
    staticClass: "slide__button-text"
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])])
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-ucat"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__ucat"
  }, [_c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "logo",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/upcloseandtasty_logo.jpg"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row-button"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('link-button', {
    attrs: {
      "url": "http://upcloseandtasty.com",
      "text": "visit the website"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "case-study__full-screenshot"
  }, [_c('img', {
    ref: "bg1",
    staticClass: "case-study__full-screenshot__bg",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/screen-bg.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    ref: "main",
    staticClass: "case-study__full-screenshot__img case-study__row case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/2017-07-06-21-40-upcloseandtasty.com.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "smores",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/smores_popsicles_upcloseandtasty_07b.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__full-screenshot"
  }, [_c('img', {
    ref: "bg2",
    staticClass: "case-study__full-screenshot__bg",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/screen-bg.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    ref: "main2",
    staticClass: "case-study__full-screenshot__img case-study__row case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/ucat/2017-07-06-21-46-upcloseandtasty.com.png",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n          Up Close & Tasty\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Freelance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Development"), _c('br'), _vm._v("Consulting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("11/2016 - Present")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n                Up Close & Tasty is a food photography blog powered by the WordPress platform. I assisted the owner in migrating the blog from Squarespace to WordPress, and have been implementing various custom stylistic and functional tweaks across the site in order to improve and smoothen its user experience.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Technology Stack")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_c('ul', [_c('li', [_vm._v("• JavaScript")]), _vm._v(" "), _c('li', [_vm._v("• HTML")]), _vm._v(" "), _c('li', [_vm._v("• CSS")]), _vm._v(" "), _c('li', [_vm._v("• PHP")])])])])
}]}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('on-mobile'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work"
  }, [_c('div', {
    ref: "overlay",
    staticClass: "overlay"
  }), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('div', {
    ref: "work",
    staticClass: "section-title"
  }, [_vm._v("Work")]), _vm._v(" "), _c('div', {
    ref: "cases",
    staticClass: "case-studies"
  }, _vm._l((_vm.caseStudies), function(caseStudy) {
    return _c('case-study', {
      key: caseStudy.to,
      attrs: {
        "title": caseStudy.title,
        "subtitle": caseStudy.subtitle,
        "to": caseStudy.to
      }
    })
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-vg"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    ref: "scrollZone",
    staticClass: "case-study__scroll-zone"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "contentBackground",
    staticClass: "case-study-content-background"
  }, [_c('div', {
    ref: "content",
    staticClass: "case-study__content case-study__row"
  }, [_c('div', {
    ref: "infos",
    staticClass: "case-study__infos"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "case-study__vidgeo"
  }, [_c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('img', {
    ref: "login",
    staticClass: "case-study__img",
    attrs: {
      "src": "/static/assets/imgs/case-study/vidgeo/N0XAiwf.png"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "phone1",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/vidgeo/rARFU1j.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "phone2",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/static/assets/imgs/case-study/vidgeo/Qcpv1p8.png",
      "alt": ""
    }
  })])])])])])]), _vm._v(" "), _vm._l((_vm.nextButtons), function(nextButton) {
    return _c('next-button', {
      key: nextButton.to,
      attrs: {
        "title": nextButton.title,
        "to": nextButton.to
      }
    })
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__hero-title"
  }, [_vm._v("\n        Vidgeo\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Context")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("Personal Project")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("UI & UX"), _c('br'), _vm._v("Front-End")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__info"
  }, [_c('div', {
    staticClass: "case-study__info__title"
  }, [_vm._v("Period")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__info__text"
  }, [_vm._v("2015")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row case-study__section"
  }, [_c('div', {
    staticClass: "case-study__section-title"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n              Vidgeo lets users record videos and pin them onto a location on the map. The idea and initial iOS application build was created during a hackathon. I created the experience and branding, sketched rapid prototypes, and created both low and high-fidelity mocks.\n            ")])])
}]}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    ref: "video",
    staticClass: "case-study__video",
    attrs: {
      "loop": ""
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    ref: "overlay",
    staticClass: "overlay"
  }), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('div', {
    ref: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', [_vm._v("is a Creative Technologist in Seattle, Washington")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports) {

module.exports = {
	"about": {
		"title": "Hey there! I’m <br><br><span class='about-content__big-title'>Raine Dalusong</span>",
		"content": "I'm currently working remotely from Seattle, Washington as a Creative Technologist for <a class='about-content__link' href='http://www.conversantmedia.com/' target='_blank'>Conversant Media</a>. I have a fierce adoration for web experiences that are both delightful and functional. During my free time, you can find me watching Japanese TV shows, studying figure skating programs, or shopping for anime merchandise.",
		"socialTitle": "You can also find me through",
		"socialNetworks": [
			{
				"name": "email",
				"link": "mailto:rainedalusong@gmail.com"
			},
			{
				"name": "twitter",
				"link": "https://twitter.com/rainedal"
			},
			{
				"name": "instagram",
				"link": "https://www.instagram.com/bumighani/"
			},
			{
				"name": "linkedin",
				"link": "https://www.linkedin.com/in/lorrainedalusong/"
			}
		]
	}
};

/***/ })
],[63]);


// WEBPACK FOOTER //
// static/js/app.8cd2340da92aaabc2f54.js